// Extracted from manor-old/stage2.php (inline SVG; embedded images moved to /manor/stage2/).
const scene = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1920 1080">
            <defs>
                <style>
                </style>
                <image id="image" width="56" height="51"
                    xlink:href="/manor/stage2/stage2-1.png" />
                <image id="image-2" width="116" height="28"
                    xlink:href="/manor/stage2/stage2-2.png" />
                <image id="image-3" width="113" height="55"
                    xlink:href="/manor/stage2/stage2-3.png" />
                <image id="image-4" width="63" height="47"
                    xlink:href="/manor/stage2/stage2-4.png" />
                <image id="image-5" width="154" height="75"
                    xlink:href="/manor/stage2/stage2-5.png" />
                <image id="image-6" width="129" height="60"
                    xlink:href="/manor/stage2/stage2-6.png" />
            </defs>
            <g id="Layer_1" data-name="Layer 1">
                <image width="1920" height="1080"
                    xlink:href="/manor/stage2/stage2-7.png" />
                <image width="1317" height="264" transform="translate(301.5)"
                    xlink:href="/manor/stage2/stage2-8.png" />
            </g>
            <g class="OG">
                <use transform="translate(1692.68 980.02)" xlink:href="#image-5" id="wrong" />
                <image width="87" height="66" id="og1" pos="1" class="clickobject" transform="translate(1505.83 889.85)"
                    xlink:href="/manor/stage2/stage2-9.png" />
                <image width="144" height="23" id="og2" pos="2" class="clickobject"
                    transform="translate(1333.61 832.96)"
                    xlink:href="/manor/stage2/stage2-10.png" />
                <use transform="translate(1259.72 758.8)" xlink:href="#image-4" id="wrong" />
                <image width="105" height="36" id="og3" pos="3" class="clickobject" transform="translate(1111.5 747.3)"
                    xlink:href="/manor/stage2/stage2-11.png" />
                <use transform="translate(951.36 753.8)" xlink:href="#image-2" id="wrong" />
                <use transform="translate(921 796.12)" id="og4" pos="4" class="clickobject" xlink:href="#image" />
                <use transform="translate(706.62 836.2) scale(1.12)" xlink:href="#image" id="wrong" />
                <use transform="translate(769.12 849.5) scale(1.17 1.38)" class="clickobject" xlink:href="#image-2"
                    id="og5" pos="5" />
                <use transform="translate(726.81 911.24)" xlink:href="#image-3" id="wrong" />
                <image width="149" height="44" id="og6" pos="6" class="clickobject" transform="translate(532.7 957.9)"
                    xlink:href="/manor/stage2/stage2-12.png" />
                <use transform="translate(362.82 967.63)" xlink:href="#image-6" id="wrong" />
                <image width="75" height="58" id="og7" pos="7" class="clickobject" transform="translate(253.35 931.99)"
                    xlink:href="/manor/stage2/stage2-13.png" />
            </g>
            <g class="Selection">
                <use transform="translate(1695.13 981.99)" xlink:href="#image-5" />
                <image width="87" height="66" id="img1" pos="1" transform="translate(1505.83 890.03)"
                    xlink:href="/manor/stage2/stage2-14.png" />
                <image width="144" height="23" id="img2" pos="2" transform="translate(1334.38 832.96)"
                    xlink:href="/manor/stage2/stage2-15.png" />
                <use transform="translate(1259.72 758.8)" xlink:href="#image-4" />
                <image width="105" height="36" id="img3" pos="3" transform="translate(1111.19 747.3)"
                    xlink:href="/manor/stage2/stage2-16.png" />
                <use transform="translate(950 753.75)" xlink:href="#image-2" />
                <image width="56" height="51" id="img4" pos="4" transform="translate(920.96 796.12)"
                    xlink:href="/manor/stage2/stage2-17.png" />
                <image width="131" height="36" id="img5" pos="5" transform="translate(769.12 852.23)"
                    xlink:href="/manor/stage2/stage2-18.png" />
                <image width="65" height="56" transform="translate(709.74 837.73)"
                    xlink:href="/manor/stage2/stage2-19.png" />
                <use transform="translate(726.81 908.49)" xlink:href="#image-3" />
                <image width="149" height="44" id="img6" pos="6" transform="translate(532.7 957.9)"
                    xlink:href="/manor/stage2/stage2-20.png" />
                <use transform="translate(360.98 970.72)" xlink:href="#image-6" />
                <image width="75" height="58" id="img7" pos="7" transform="translate(253.35 931.99)"
                    xlink:href="/manor/stage2/stage2-21.png" />
            </g>
        </svg>`;

export default scene;
